import { createRoot } from "react-dom/client";

import "@/theme/kanzArabicFontFace.css";

import App from "@/App";
import * as serviceWorker from "@/serviceWorker";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

const root = createRoot(container);
root.render(<App />);

serviceWorker.register();
